import { Container, Grid, Tab, Tabs, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';

import moment from 'moment';
import useLeagues from 'hooks/useLeagues';
import useAuth from 'hooks/useAuth';
import useUsers from 'hooks/useUsers';
import { gridSpacing } from 'store/constant';
import HorizontalItemCard from 'ui-component/cards/HorizontalCard';
import { useNavigate } from 'react-router-dom';
import getReadableDateTime from 'utils/get_readable_datetime';

const PlayerReservations = () => {
    const navigate = useNavigate();
    const groupTicketsByMonth = (tickets) => {
        const groups = tickets.reduce((acc, ticket) => {
            const month = moment(ticket.start_time).format('MMMM YYYY'); // E.g., 'January 2021'
            if (!acc[month]) {
                acc[month] = { data: [], itemCount: 0 };
            }
            acc[month].data.push(ticket);
            acc[month].itemCount += 1;
            return acc;
        }, {});

        let cumulativeCount = 0;
        return Object.keys(groups).map((month) => {
            const section = {
                title: month,
                data: groups[month].data,
                indexOffset: cumulativeCount
            };
            cumulativeCount += groups[month].itemCount;
            return section;
        });
    };

    const { getPlayerReservations, playerReservations } = useUsers();
    const [groupedTickets, setGroupedTickets] = useState([]);
    const [selectedTab, setSelectedTab] = useState(1);
    const { user } = useAuth();
    const key = { 1: 'upcoming', 2: 'previous' };

    useEffect(() => {
        getPlayerReservations(key[selectedTab]);
    }, [user?.id, selectedTab]);

    useEffect(() => {
        if (playerReservations) {
            setGroupedTickets(groupTicketsByMonth(playerReservations));
        }
    }, [playerReservations]);
    console.log('groupedTickets', groupedTickets);
    return (
        <Container>
            <Grid container spacing={gridSpacing}>
                <Grid item xs={12}>
                    <Typography variant="h2"> Your Reservations</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Tabs value={selectedTab} onChange={(e, newValue) => setSelectedTab(newValue)}>
                        <Tab label="Upcoming" value={1} />
                        <Tab label="Previous" value={2} />
                    </Tabs>
                </Grid>
                <Grid item xs={12}>
                    <Grid container spacing={gridSpacing}>
                        {groupedTickets?.map((month) => (
                            <Grid item xs={12} key={month.title}>
                                <Typography mb={2} variant="h4">
                                    {month.title}
                                </Typography>
                                <Grid container spacing={gridSpacing}>
                                    {month.data?.map((item) => (
                                        <Grid item xs={12}>
                                            <HorizontalItemCard
                                                clickAction={() => navigate(`/user/reservation/${item.id}`)}
                                                date={item.start_time}
                                                image={item.court?.club?.image?.image_url}
                                                content={
                                                    <Grid>
                                                        <Typography variant="h3">
                                                            {item?.court?.club?.name} - {item.court?.name}
                                                        </Typography>
                                                        <Typography variant="caption">
                                                            {getReadableDateTime(item.start_time, 'time')} -{' '}
                                                            {getReadableDateTime(item.end_time, 'time')}
                                                        </Typography>
                                                        <br />
                                                        <Typography variant="caption">
                                                            {' '}
                                                            Order {item?.id} of (${item?.total_cost / 100}) purchase on{' '}
                                                            {getReadableDateTime(item?.created_at, 'dateshort')} at {item.court?.club?.name}
                                                        </Typography>
                                                    </Grid>
                                                }
                                            />
                                        </Grid>
                                    ))}
                                </Grid>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Grid>
        </Container>
    );
};

export default PlayerReservations;
